import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Heart, Shield, Users, Sparkles } from 'lucide-react';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[#FCFAF8] flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <span className="inline-block bg-[#FFF5F5] text-[#D48585] text-xs font-body font-semibold px-3 py-1 rounded-full mb-4">About Us</span>
        <h1 className="font-heading text-3xl sm:text-4xl text-[#2C2A29] mb-6" data-testid="about-title">What is {'{'}Beauty{'}'} Stashmart?</h1>

        <div className="prose font-body text-[#4A4745] leading-relaxed space-y-5">
          <p>
            <strong>{'{'}Beauty{'}'} Stashmart</strong> is a social marketplace where beauty lovers and influencers sell beauty products &mdash; from personal stashes to PR products, brand gifts, and endorsement items &mdash; at great prices.
          </p>

          <p>
            We are a <strong>C2C (consumer-to-consumer) platform</strong> &mdash; individual to individual. {'{'}Beauty{'}'} Stashmart is <em>not</em> an official store, brand distributor, or wholesaler. Every product listed comes from a real person &mdash; whether it's from their personal stash, PR gifts from brands, or endorsement products.
          </p>

          <div className="grid sm:grid-cols-2 gap-4 my-8">
            <div className="bg-white rounded-2xl p-5 border border-cream-100/50">
              <Heart size={24} className="text-[#F4C2C2] mb-3" />
              <h3 className="font-heading text-base text-[#2C2A29] mb-1">For Beauty Lovers</h3>
              <p className="text-sm text-[#78716C]">Discover authentic beauty products at great prices from people who genuinely love skincare and makeup.</p>
            </div>
            <div className="bg-white rounded-2xl p-5 border border-cream-100/50">
              <Sparkles size={24} className="text-[#C5A880] mb-3" />
              <h3 className="font-heading text-base text-[#2C2A29] mb-1">For Influencers</h3>
              <p className="text-sm text-[#78716C]">Share your beauty insights, sell products you've reviewed, and connect with your community.</p>
            </div>
            <div className="bg-white rounded-2xl p-5 border border-cream-100/50">
              <Shield size={24} className="text-[#78716C] mb-3" />
              <h3 className="font-heading text-base text-[#2C2A29] mb-1">Verified Sellers</h3>
              <p className="text-sm text-[#78716C]">Our influencer verification system helps build trust, so you know who you're buying from.</p>
            </div>
            <div className="bg-white rounded-2xl p-5 border border-cream-100/50">
              <Users size={24} className="text-[#D48585] mb-3" />
              <h3 className="font-heading text-base text-[#2C2A29] mb-1">Community First</h3>
              <p className="text-sm text-[#78716C]">More than a marketplace &mdash; it's a community where beauty enthusiasts share tips, reviews, and their favorite finds.</p>
            </div>
          </div>

          <h2 className="font-heading text-xl text-[#2C2A29] mt-8">How It Works</h2>
          <ol className="list-decimal pl-5 space-y-2 text-sm">
            <li><strong>Create your profile</strong> &mdash; Tell us about your skin type, concerns, and beauty story.</li>
            <li><strong>List your products</strong> &mdash; Upload photos, describe condition, remaining amount, expiry date, and why you're selling. Each listing is limited to 1 unit. Regular users can have up to 10 active listings; verified influencers can have up to 25.</li>
            <li><strong>Browse &amp; buy</strong> &mdash; Discover pre-loved beauty treasures from other community members.</li>
            <li><strong>Pay securely</strong> &mdash; Transactions are processed through <strong>Duitku</strong>, supporting Virtual Accounts, QRIS, and convenience store payments.</li>
            <li><strong>Ship or meet up</strong> &mdash; Arrange delivery via courier or a local meet-up.</li>
          </ol>
          <p className="text-sm text-[#78716C] mt-3">
            To keep {'{'}Beauty{'}'} Stashmart a trusted community, we use automated systems to detect and prevent commercial or store-like activity. This platform is for individuals only &mdash; not shops or distributors.
          </p>

          <h2 className="font-heading text-xl text-[#2C2A29] mt-8">Beta Notice</h2>
          <p className="text-sm">
            {'{'}Beauty{'}'} Stashmart is currently in <strong>beta</strong>. We are actively improving the platform based on user feedback. Some features may change, and we appreciate your patience as we grow. If you encounter any issues or have suggestions, please contact us at{' '}
            <a href="mailto:hello@stashmart.store" className="text-[#D48585] underline">hello@stashmart.store</a>.
          </p>
        </div>

        <div className="mt-10 flex gap-3">
          <Link to="/terms" className="text-sm font-body font-semibold text-[#C5A880] hover:underline">Terms &amp; Conditions</Link>
          <span className="text-[#A89F91]">&middot;</span>
          <Link to="/privacy" className="text-sm font-body font-semibold text-[#C5A880] hover:underline">Privacy Policy</Link>
          <span className="text-[#A89F91]">&middot;</span>
          <Link to="/contact" className="text-sm font-body font-semibold text-[#C5A880] hover:underline">Contact</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
